import { IHttpException } from "@interfaces/IHttpException";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { IUser } from "@interfaces/IUser";
import { AccountService } from "@services/account.service";
import { ConstantsService } from "@services/constantsService";
import { UsersService } from "@services/users.service";
import * as angular from "angular";
import './passwordEditor.component.scss';

interface IComponentBindings {
    forcePasswordReset: boolean;
    onCancelled?: () => void;
    onPasswordUpdated?: () => void;
}

class PasswordEditorComponentController implements angular.IComponentController, IComponentBindings {

    // bindings
    forcePasswordReset: boolean;
    onCancelled: () => void;
    onPasswordUpdated: () => void;

    // form changes
    currentPassword: string;
    newPassword1: string;
    newPassword2: string;
    isSavingPassword: boolean;
    isFormValid: boolean;

    currentUser: IUser;
    isMobile: boolean;

    autocompleteId: number = Date.now();

    static $inject = ["$q", "$rootScope", "$window", "usersService", "accountService", "constantsService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $rootScope: IRunBlockRootScope,
        private readonly $window: angular.IWindowService,
        private readonly usersService: UsersService,
        private readonly accountService: AccountService,
        private readonly constantsService: ConstantsService) {
    }

    $onInit(): void {
        this.isMobile = this.constantsService.getIsMobile();
        this.currentUser = angular.copy(this.$rootScope.currentUser);
    }

    onFormUpdated(): void { }

    validateForm() {
        this.isFormValid = this.newPassword1 === this.newPassword2;
    }

    cancel(): void {
        if (this.onCancelled) {
            this.onCancelled();
        }
    }

    save(newPassword: string): void {
        if (this.isSavingPassword) {
            return;
        }

        let failedToSave = false;
        this.isSavingPassword = true;



        const promises: angular.IPromise<any>[] = [];
        promises.push(this.accountService.changePassword(this.newPassword2));

        if (this.forcePasswordReset) {
            this.currentUser.ResetPassword = false;
            promises.push(this.usersService.save(this.currentUser));
        }

        this.$q.all(promises).then(() => {

        }).catch((exception: angular.IHttpPromiseCallbackArg<IHttpException>) => {
            failedToSave = true;
        }).finally(() => {
            this.isSavingPassword = false;

            if (failedToSave) {
                return;
            }

            this.$window.location.reload(true);
        });
    }
}

export class PasswordEditorComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            forcePasswordReset: "<",
            onCancelled: "&",
            onPasswordUpdated: "&"
        };

        this.controller = PasswordEditorComponentController;
        this.template = require("./passwordEditor.component.html");
    }
}
